import type { CustomLocale } from 'flatpickr/dist/types/locale';
import type { TFunction } from 'i18next';

type string_7 = [string, string, string, string, string, string, string];
type string_12 = [
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
];

export const daysAndMonths = (
  t: TFunction<['common']>
): Pick<CustomLocale, 'weekdays' | 'months'> => {
  const shortDays = t('common:short_weekdays', {
    defaultValue: null,
  }) as string_7;
  const longDays = t('common:long_weekdays', {
    defaultValue: null,
  }) as string_7;
  const shortMonths = t('common:short_months', {
    defaultValue: null,
  }) as string_12;
  const longMonths = t('common:long_months', {
    defaultValue: null,
  }) as string_12;
  return {
    ...(!!(shortDays && longDays) && {
      weekdays: {
        shorthand: shortDays,
        longhand: longDays,
      },
    }),
    ...(!!(shortMonths && longMonths) && {
      months: {
        shorthand: shortMonths,
        longhand: longMonths,
      },
    }),
  };
};
